import React, { Fragment, useState } from 'react';
import { tl } from 'common/services/i18nService';
import { Popup, Divider, Dropdown } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import * as menuStyles from 'common/components/header/Header.scss';
import { isNullOrUndefined } from 'common/util/utils';
import { SyncInfo } from './SyncInfo';
import { SyncData } from './SyncData';
import { SyncActions } from './SyncActions';
import { GradesTransfer } from './GradesTransfer';
import {
    getExternalSystemName,
    getSyncActions,
    isSyncAllowedForAssessmentRun,
} from '../../services/externalSystemService';
import { hasCurrentUserPlannerPrivilege } from '../../../../services/permissions/PermissionService';
import { RootState } from '../../../../store/rootReducer';
import { ExternalSystem } from '../../../../store/common/constants';

export interface ModalConfig {
    title: string;
    isOpen: boolean;
    currentTransfer: string;
}

export const ExternalInfoButton: React.FC = React.memo(() => {
    const isSyncAvailable = isSyncAllowedForAssessmentRun();
    const isPlanner = hasCurrentUserPlannerPrivilege();
    const { assessment } = useSelector((state: RootState): RootState => state);
    const {
        externalSystem,
        subjectCode,
        subjectTitle,
        variant,
        versionCode,
        evaluationType,
        amqpEnabled,
    } = assessment;
    const initialState: ModalConfig = {
        title: '',
        isOpen: false,
        currentTransfer: '',
    };
    const [popupOpen, setPopUpOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState(initialState);
    const syncData = [];
    if (!isNullOrUndefined(subjectCode) || !isNullOrUndefined(versionCode)) {
        syncData.push({
            title: tl('grading.syncButton.subjectCode'),
            content: `${subjectCode || ''} ${versionCode || ''}`.trim(),
            id: 1,
        });
    }
    if (!isNullOrUndefined(evaluationType)) {
        syncData.push({
            title: tl('grading.syncButton.evaluationType'),
            content: evaluationType || '',
            id: 2,
        });
    }
    if (!isNullOrUndefined(subjectTitle)) {
        syncData.push({
            title: tl('grading.syncButton.subjectTitle'),
            content: subjectTitle || '',
            id: 3,
        });
    }
    if (!isNullOrUndefined(variant)) {
        syncData.push({
            title: tl('grading.syncButton.variant'),
            content: variant || '',
            id: 4,
        });
    }

    const onOpenPopup = () => {
        setPopUpOpen(true);
    };

    const onClosePopup = () => {
        if (modalConfig.isOpen) {
            return;
        }

        setPopUpOpen(false);
    };
    const externalSystemText = getExternalSystemName(externalSystem as ExternalSystem);
    const showTransferGradesContent = !isNullOrUndefined(externalSystem)
        && (externalSystem === ExternalSystem.FS
            || externalSystem === ExternalSystem.LADOK
            || (externalSystem === ExternalSystem.API && amqpEnabled));

    if (!isPlanner && !syncData.length) {
        return null;
    }

    return (
        <Popup
            position="bottom right"
            on="click"
            trigger={<Dropdown button basic text={externalSystemText} />}
            className={menuStyles.fsPopUp}
            open={popupOpen}
            onOpen={onOpenPopup}
            onClose={onClosePopup}
        >
            <div className={menuStyles.syncPopUpContainer}>
                {isPlanner && (
                    <Fragment>
                        {isSyncAvailable
                            ? (
                                <React.Fragment>
                                    <SyncInfo />
                                    <SyncActions actionData={getSyncActions()} />
                                    {syncData.length > 0 || showTransferGradesContent
                                        ? <Divider />
                                        : null}
                                </React.Fragment>
                            ) : null}
                        {showTransferGradesContent
                            ? (
                                <React.Fragment>
                                    <GradesTransfer
                                        modalConfig={modalConfig}
                                        setModalConfig={setModalConfig}
                                        initialState={initialState}
                                    />
                                    {syncData.length > 0
                                        ? <Divider />
                                        : null}
                                </React.Fragment>
                            ) : null}
                    </Fragment>
                )}
                {syncData.length
                    ? <SyncData data={syncData} />
                    : null}
            </div>
        </Popup>
    );
});
